import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		widgetUserEvent: [...mycarsSrpVdp.widgetUserEvent],
		'ddc.link.generic': [
			{
				logic: ({
					eventData: { attributes: { class: classes = '' } = {}, url }
				}) =>
					classes.includes('window-sticker-link') ||
					classes.includes('windowsticker') ||
					classes.includes('window-sticker-img-2') ||
					url.includes('windowsticker') ||
					url.includes('windowSticker'),
				payload: ({
					eventData: {
						vehicle: { year, make, model }
					}
				}) => {
					const vehicle = window.digitaldata?.vehicle || {};
					const nameplate = `${make} ${model}`;
					vehicle.modelYear = year;
					vehicle.nameplate = nameplate;

					const payload = {
						onclick: {
							onclick: `{inventoryType}:si:vehicle details:view window sticker:${nameplate}`,
							onclickLinkName: `{client}{inventoryType}:si:vehicle details:view window sticker:${nameplate}`
						},
						page: {
							tool: 'event:window sticker',
							toolDescriptor: 'vehicle details:window sticker'
						},
						event: {
							action: 'window sticker|tool'
						},
						vehicle
					};

					return {
						directCall: 'window-sticker',
						payload
					};
				}
			}
		]
	}
};
